import { createUseStyles } from 'react-jss';

export const useStyles = createUseStyles(() => ({
    form: { display: 'flex', flexDirection: 'column', gap: 14, paddingTop: 6 },
}));
